"use client";

import { Grid, Keyboard, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import type { SwiperOptions } from "swiper/types";

import WelcomeBanner from "@/components/Banner/components/Welcome/WelcomeBanner";
import styles from "@/components/Banner/Banner.module.scss";

const SLIDES = [
  // { key: "valentines", render: () => <ValentinesBanner /> },
  { key: "welcome", render: () => <WelcomeBanner /> },
];

export default function Banner() {
  const SETTINGS_SLIDER: SwiperOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    watchOverflow: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  };

  return (
    <section className="section">
      <Swiper {...SETTINGS_SLIDER} modules={[Navigation, Grid, Keyboard, Autoplay]}>
        {SLIDES.map((s) => (
          <SwiperSlide key={s.key} className={styles.slide}>
            {s.render()}
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
